"use client";

import { Button } from "@/components/actions/Button";
import { useNav } from "@/providers/Nav";

export default function Nav() {
  const { navRetracted } = useNav();
  return (
    <nav
      className={`sticky  transition-all duration-300 ease-in-out ${navRetracted ? "top-0" : "top-[80px]"} z-[15000] bg-white py-6`}
    >
      <div className="contianer mx-auto flex justify-start md:justify-center gap-8 items-center overflow-auto px-gutter">
        <div className="relative inline-block w-max">
          <select
            className="block appearance-none h-[48px] w-max  max-w-[200px] bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 leading-tight focus:outline-none focus:shadow-outline"
            onChange={(e) => {
              if (e.target.value) {
                window.location.href = e.target.value;
              }
            }}
          >
            <option>Available Series</option>
            <option value="/series/aspiro-series">Aspiro® Series</option>
            <option value="/series/cendura-series">Cendura® Series</option>
          </select>
        </div>
        <Button
          href="/technical-resources"
          variant="secondary"
          isLight
          size="small"
        >
          Resources
        </Button>
        <Button href="/samples" variant="secondary" isLight size="small">
          Order Samples
        </Button>
        <Button href="/contact-us" variant="secondary" isLight size="small">
          Contact Us
        </Button>
      </div>
    </nav>
  );
}
